// src/pages/PasswordRecovery/RecoveryVerifyPhoneOtp.tsx
import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from '@tanstack/react-router';

import { useAppDispatch } from '@/store';
import {
  selectRecoveryToken,
  selectRecoveryMaskedPhone,
} from '@/store/selectors/auth';
import { verifyRecoveryTwoFactorThunk } from '@/store/thunks/auth/verifyRecoveryTwoFactorThunk';
import RecoveryVerifyPhoneOtpForm from '@/components/organism/PasswordRecovery/RecoveryVerifyPhoneOtpForm';

const OTP_LENGTH = 6;

export default function RecoveryVerifyPhoneOtp() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const recoveryToken = useSelector(selectRecoveryToken);
  const maskedPhone = useSelector(selectRecoveryMaskedPhone);

  const handleSubmit = React.useCallback(
    async(code: string): Promise<void> => {
      if (code.trim().length !== OTP_LENGTH) return;

      try {
        await dispatch(verifyRecoveryTwoFactorThunk({ code })).unwrap();
        void navigate({ to: '/reset-password/set-password' });
      } catch {
        // error handled in redux
      }
    },
    [dispatch, navigate, recoveryToken]
  );

  return (
    <RecoveryVerifyPhoneOtpForm
      maskedPhone={maskedPhone}
      onSubmit={(code) => {
        void handleSubmit(code);
      }}
    />
  );
}
